module.exports = __webpack_public_path__ + "img/product.41eb085c.svg";